import React from "react";
import { BattingLineup } from "./batting-lineup";
import { PitchingLineup } from "./pitching-lineup";

export const GameLineups = ({ battingLineups = [], pitchingLineups = [], homeTeam, awayTeam, homeTeamId, awayTeamId }) => {
  const awayBatting = battingLineups.filter((p) => p.team_id === awayTeamId);
  const homeBatting = battingLineups.filter((p) => p.team_id === homeTeamId);
  const awayPitching = pitchingLineups.filter((p) => p.team_id === awayTeamId);
  const homePitching = pitchingLineups.filter((p) => p.team_id === homeTeamId);

  return (
    <div className="space-y-6">
      <div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <BattingLineup lineup={awayBatting} teamName={awayTeam} teamId={awayTeamId} />
          </div>
          <div>
            <BattingLineup lineup={homeBatting} teamName={homeTeam} teamId={homeTeamId} />
          </div>
        </div>
      </div>

      <div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <PitchingLineup lineup={awayPitching} teamName={awayTeam} teamId={awayTeamId} />
          </div>
          <div>
            <PitchingLineup lineup={homePitching} teamName={homeTeam} teamId={homeTeamId} />
          </div>
        </div>
      </div>
    </div>
  );
};
